import { withStyles } from 'vopay';
import styles from './AccountPickerOption.module.scss';

const cn = withStyles(styles);

type AccountPickerOptionProps = {
  name: string;
  /** The already-worded balance line ("Available Balance: CAD $1,500.00"). */
  balanceLine: string;
};

/**
 * One row of a transfer account picker (ID-13981): the account name, then its balance on a second,
 * greyed line. The option is inside a listbox `<li>`, so the Body/16 text styles live in the module
 * SCSS rather than in BodyText's block `<div>`s.
 */
export default function AccountPickerOption({ name, balanceLine }: AccountPickerOptionProps) {
  return (
    <span className={cn('option')}>
      <span className={cn('name')}>{name}</span>
      <span className={cn('balance')}>{balanceLine}</span>
    </span>
  );
}
